import Api from './Api'

export default {
  getChargers () {
    return Api().get('/evses')
  }
}